import { useAuthedUserContext } from '@/clients/shared-hooks/use-authed-user';
import { hasAdminEntitlement } from '@/ifaces/entitlements';
import { UserButton } from '@clerk/clerk-react';
import { useLingui } from '@lingui/react/macro';
import { ChartColumnBig, Library, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router';

export function UserAvatarMenu() {
  const navigate = useNavigate();
  const { t } = useLingui();
  const { entitlements, customer } = useAuthedUserContext();
  return (
    <UserButton userProfileUrl="/profile">
      <UserButton.MenuItems>
        {(entitlements.can_view_reports || entitlements.can_view_user_reports) && (
          <UserButton.Action
            label={t`Progress Dashboard`}
            labelIcon={<ChartColumnBig size={16} />}
            onClick={() => navigate('/reporting/progress')}
          />
        )}
        {customer.enablePlatformBeta && (
          <UserButton.Link
            label={t`Content Catalog`}
            labelIcon={<Library size={16} />}
            href="/platform"
          />
        )}
        {hasAdminEntitlement(entitlements) && (
          <UserButton.Action
            label={t`Admin Panel`}
            labelIcon={<Wrench size={16} />}
            onClick={() => (window.location.href = '/_sys/')}
          />
        )}
      </UserButton.MenuItems>
    </UserButton>
  );
}
